var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortAscending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.80361 1.44788H5.24202L8.21755 9.17226H6.76787L6.04304 7.12757H2.95977L2.23494 9.17226H0.839355L3.80361 1.44788ZM3.3276 6.09936H5.68603L4.52845 2.77855H4.496L3.3276 6.09936ZM1.71069 14.43H7.58467V15.4573L3.08464 20.9865H7.6933V22.1549H1.36405V21.0514L5.86453 15.5984H1.71069V14.43Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6968 14.9927L18.1398 18.5493L14.5828 14.9927H21.6968ZM18.1398 5.23853V18.0607V5.23853Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1398 5.23853V18.0607M21.6968 14.9927L18.1398 18.5493L14.5828 14.9927H21.6968Z",
    stroke: "#878787",
    strokeWidth: 1.80308,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.44,
    height: 22.5385,
    fill: "white",
    transform: "translate(0.560059 0.730713)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAscending);
export default __webpack_public_path__ + "static/media/sort-ascending.bb4d12de655785ce939730346adc4a1e.svg";
export { ForwardRef as ReactComponent };